import React from 'react';
import { Div } from '@pezeshk-book/ui-kit';
import { CurveContainerProps } from './curve-container.props';
import classNames from '@utils/helpers/class-names';

const CurveContainer = ({ gray, children, firstContainer, lastContainer, column, className, childrenClassName }: CurveContainerProps) => {
  return (
    <Div className={classNames(gray ? 'bg-white' : 'bg-darkBlue-50', className)}>
      <Div className={classNames(
        'w-full flex relative',
        gray
          ? 'bg-darkBlue-50 rounded-bl-[20px] rounded-tl-[20px] sm:rounded-bl-[40px] sm:rounded-tl-[40px] md:rounded-bl-[60px] md:rounded-tl-[60px]'
          : 'bg-white rounded-br-[20px] rounded-tr-[20px] sm:rounded-br-[40px] sm:rounded-tr-[40px] md:rounded-br-[60px] md:rounded-tr-[60px]',
        column ? 'flex-col' : 'flex-row-reverse justify-center',
        firstContainer ? '!rounded-tr-none' : '',
        lastContainer ? '!rounded-br-none !rounded-bl-none' : '',
      )}>
        <Div className={classNames('w-full max-w-[1400px] md:py-8 py-3 px-3 md:px-0', childrenClassName)}>
          {children}
        </Div>
      </Div>
    </Div>
  );
};

export default CurveContainer;
